<template>
  <div class="order-flow-wrap" :style="{ height: viewportHeight }">
    <div class="order-flow-wrap-container">
      <div class="order-flow-item" v-for="(item, idx) in orderIdList" :key="item.label">
        <div class="text-box">
          <label>{{ item.step }}:</label>
          <span>{{ item.label }}</span>
        </div>
        <img :src="item.img" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      viewportHeight: 0,
      orderIdList: [
        {
          label: this.$t('flow.step1'),
          step: 'Step1',
          img: require('@/assets/step1.png'),
        },
        {
          label: this.$t('flow.step2'),
          step: 'Step2',
          img: require('@/assets/step2.png'),
        },
        {
          label: this.$t('flow.step3'),
          step: 'Step3',
          img: require('@/assets/step3.png'),
        },
        {
          label: this.$t('flow.step4'),
          step: 'Step4',
          img: require('@/assets/step4.png'),
        },
      ],
    };
  },
  mounted() {
    this.viewportHeight = window.innerHeight + 'px';
    if (this.$store.getters.form) {
      this.form = this.$store.getters.form;
    }
  },
  methods: {},
};
</script>

<style>
.order-flow-wrap {
  width: 100%;
  height: 100vh;
  background-color: #fff;
  position: relative;
  .order-flow-wrap-container {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    padding: 16px;
    max-width: 600px;
    background-color: #f0f0f0;
    overflow: scroll;
    display: flex;
    flex-direction: column;
    gap: 24px;
    .order-flow-item {
      background-color: #fff;
      padding: 12px;
      border-radius: 16px;
      .text-box {
        margin-bottom: 8px;
        label {
          font-size: 32px;
          font-weight: 500;
          margin-right: 8px;
          color: #1a1a1a;
        }
        span {
          font-size: 24px;
          font-weight: 500;
          margin-right: 8px;
          margin-bottom: 8px;
          color: #595959;
        }
      }

      img {
        width: 100%;
      }
    }
  }
}
</style>
